import React from "react";
import { Ticket } from "../components/Pages/Ticket";
import { PixConfirmation } from "../components/Pages/PixConfirmation";
import { Navigate, Route } from "react-router-dom";
import { Pix } from "../components/Pages/Pix";
import { Payment } from "../components/Pages/Payment";
import { ProtectedRoute } from "../components/Atoms/ProtectedRoute";
import { Vehicle } from "../components/Pages/Vehicle";
import { Survey } from "../components/Pages/Survey";
import { License } from "../components/Pages/License";
import { AddressRegistration } from "../components/Pages/AddressRegistration";
import { Services } from "../components/Pages/Services";
import { UserRegistration } from "../components/Pages/UserRegistration";
import { LoginRegister } from "../components/Pages/LoginRegister";
import { ConfirmAppointment } from "../components/Pages/ConfirmAppointment";
import { ScheduleConfirmation } from "../components/Pages/ScheduleConfirmation";
import { Login } from "../components/Pages/Login";
import { LayoutTemplate } from "../components/Templates/LayoutTemplate";
import { Delivery } from "../components/Pages/Delivery";
import { Store } from "../components/Pages/Store";
import { PixCancellation } from "../components/Pages/PixCancellation";
import { TicketCancellation } from "../components/Pages/TicketCancellation";
import { ConcessionaireAddressRegister } from "../components/Pages/ConcessionaireAdressRegister";
import { Invoice } from "../components/Pages/Invoice";
import { DispatcherCustomer } from "../components/Pages/DispatcherCustomer";
import { DispatcherCustomerRegister } from "../components/Pages/DispatcherCustomerRegister";
import { DispatcherCustomerDetail } from "../components/Pages/DispatcherCustomerDetail";
import { RefundForm } from "../components/Pages/RefundForm";
import { ListItinerants } from "../components/Pages/ListItinerants";
import { VehicleRegister } from "../components/Pages/VehicleRegister";
import { DelayNotification } from "../components/Pages/DelayNotification";
import { ImpedimentRegister } from "../components/Pages/ImpedimentRegister";
import { Auth } from "../components/Pages/Auth";

export const useAgendamentoByIdRoutes = () => {
  return (
    <Route path="/agendamento/:uuidAgendamento?" element={<LayoutTemplate />}>
      <Route path="auth">
        <Route index element={<Auth />} />
        <Route path="login" element={<Login />} />
        <Route path="cadastro-usuario" element={<UserRegistration />} />
      </Route>
      <Route path="login" element={<Navigate to="../auth/login" replace />} />
      <Route
        path="cadastro-usuario"
        element={<Navigate to="../auth/cadastro-usuario" replace />}
      />
      <Route path="confirmar-horario" element={<ScheduleConfirmation />} />
      <Route path="fatura" element={<Invoice />} />

      <Route path="confirmar-agendamento" element={<ConfirmAppointment />} />
      <Route path="login-cadastro" element={<LoginRegister />} />
      <Route path="domicilio" element={<Delivery />} />
      <Route path="loja" element={<Store />} />

      <Route path="despachante-cliente">
        <Route index element={<DispatcherCustomer />} />
        <Route
          path="cadastro-cliente"
          element={<DispatcherCustomerRegister />}
        />
        <Route path="detalhe-cliente" element={<DispatcherCustomerDetail />} />
      </Route>

      <Route path="itinerantes" element={<ListItinerants />} />

      <Route path="servicos">
        <Route index element={<Services />} />
        <Route
          path="cadastro-endereco-concessionaria"
          element={<ConcessionaireAddressRegister />}
        />
        <Route path="cadastro-endereco" element={<AddressRegistration />} />
        <Route path="emplacamento" element={<License />} />
        <Route path="vistoria" element={<Survey />} />
        <Route path="veiculo" element={<Vehicle />} />
        <Route path="primeiro-registro" element={<VehicleRegister />} />
      </Route>

      <Route path="pagamento">
        <Route
          index
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />
        <Route path="pix">
          <Route index element={<Pix />} />
          <Route path="confirmacao-pagamento" element={<PixConfirmation />} />
        </Route>
        <Route path="boleto" element={<Ticket />} />
        <Route path="cancelamento-pix" index element={<PixCancellation />} />
        <Route
          path="cancelamento-boleto"
          index
          element={<TicketCancellation />}
        />{" "}
        <Route path="formulario-reembolso" index element={<RefundForm />} />
      </Route>
      <Route path="comunicar-atraso" element={<DelayNotification />} />
      <Route path="registrar-impedimento" element={<ImpedimentRegister />} />
    </Route>
  );
};
